module.exports = __webpack_public_path__ + "src/assets/img/engine_four.a6acae99.svg";